import React from "react";
import { Skeleton, Stack } from "@mui/material";
import { TableSkeleton } from "../../../components";

export const ShipmentItemTableSkeleton = () => {
  return (
    <Stack gap="10px">
      <Skeleton height="23px" variant="rounded" />
      <TableSkeleton rows={2} rowHeight="30px" headerHeight="31px" />
    </Stack>
  );
};

export default ShipmentItemTableSkeleton;
